import { adminTypes } from "app/redux/type/adminTypes";

const initialState = {
  isLoading: false,
  dashboardData: null,
  eventDetails: null,
  msg: "",
};
export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case adminTypes.GET_ADMIN_DASHBOARD_DATA_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        dashboardData: action.payload,
        msg: "",
      };
    case adminTypes.GET_ADMIN_DASHBOARD_DATA_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        dashboardData: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};
